import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export interface InvestmentTransactionDetails {
  id: number;
  investmentId: number;
  interestRate: number | null;
  interestRateType: string | null;
  contractFileUuid: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface InvestmentTransactionType {
  id: number;
  uuid: string;
  investmentId: number;
  type: "buy" | "sell";
  quantity: number | null;
  unitPrice: number | null;
  totalValue: number | null;
  calculatedUnitPrice: number | null;
  currencyUuid: string;
  note: string | null;
  fileId: number | null;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
  currency: {
    uuid: string;
    short: string;
    name: string;
    currency: string;
  } | null;
  file: any | null;
}

export interface InvestmentTransactionsResponse {
  transactions: InvestmentTransactionType[];
  details: InvestmentTransactionDetails | null;
}

export default function useGetInvestmentTransactions(uuid: string | null, investmentShareUuid?: string | null) {
  return useQuery({
    queryKey: ["investmentTransactions", uuid, investmentShareUuid ?? null],
    queryFn: async () => {
      const params = investmentShareUuid ? `?shareUuid=${investmentShareUuid}` : '';
      return axiosInstance
        .get(`/investments/${uuid}/transactions${params}`)
        .then((res) => res.data);
    },
    retry: false,
    enabled: !!uuid,
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
